<template>
    <div>
        <AxTieredMenu ref="tieredMenuRef" :model="actions" :popup="true" />
        <AxButton
            ref="buttonRef"
            severity="secondary"
            size="small"
            :icon="icon"
            :variant="variant"
            :label="label"
            :disabled="disabled"
            @click.stop="handleClick"
        />
    </div>
</template>

<script setup lang="ts">
import { AxButton, AxTieredMenu } from '@axxone-system/hades';
import type { AxTieredMenuProps, AxButtonProps } from '@axxone-system/hades';
import { ref } from 'vue';

type AxMenuButtonProps = {
    actions: AxTieredMenuProps['model'];
    variant?: AxButtonProps['variant'];
    disabled?: AxButtonProps['disabled'];
    label?: AxButtonProps['label'];
    icon?: AxButtonProps['icon'];
};

defineOptions({
    customOptions: {
        name: 'AxMenuButton',
    },
});

defineProps({
    actions: {
        type: Array as () => (AxMenuButtonProps['actions']),
        required: true,
    },
    variant: {
        type: String as () => AxMenuButtonProps['variant'],
        default: 'text',
    },
    disabled: {
        type: Boolean as () => AxMenuButtonProps['disabled'],
        default: false,
    },
    label: {
        type: String as () => AxMenuButtonProps['label'],
        default: '',
    },
    icon: {
        type: String as () => AxMenuButtonProps['icon'],
        default: 'ax ax-overflow-menu-vertical',
    },
});



const buttonRef = ref<InstanceType<typeof AxButton> | null>(null);
const tieredMenuRef = ref<InstanceType<typeof AxTieredMenu> | null>(null);

const handleClick = (event: MouseEvent) => {
    if (tieredMenuRef.value && buttonRef.value) {
        buttonRef.value.changeState('active');
        tieredMenuRef.value.toggle(event, buttonRef.value);
    }
    emit('click', event);
};

function hide() {
    if (tieredMenuRef.value) {
        tieredMenuRef.value?.hide();
    }
};

function toggle(event: MouseEvent) {
    if (tieredMenuRef.value && buttonRef.value) {
        tieredMenuRef.value?.toggle(event, buttonRef.value);
    }
};

const emit = defineEmits(['click']);

defineExpose({
    toggle,
    hide,
});

</script>

